var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatIcon = function SvgChatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9758 7.51343V4.30613C19.9758 3.04584 18.9542 2.02417 17.6939 2.02417H4.30637C3.04609 2.02417 2.02441 3.04584 2.02441 4.30613V14.7207C2.02441 15.981 3.04609 17.0027 4.30637 17.0027C4.69849 17.0027 5.01633 17.3205 5.01633 17.7126V18.9178C5.01633 19.502 5.48991 19.9756 6.07409 19.9756C6.35466 19.9756 6.62374 19.8642 6.82208 19.6658L9.27721 17.2106C9.41036 17.0775 9.59094 17.0027 9.7792 17.0027H17.6939C18.9542 17.0027 19.9758 15.981 19.9758 14.7207V12.6171",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5186 13.1002H8.51855C7.96627 13.1002 7.51855 12.6524 7.51855 12.1002V8.85104C7.51855 8.54521 7.6585 8.2562 7.89842 8.06654L10.3984 6.09031C10.7619 5.80297 11.2752 5.80297 11.6387 6.09031L14.1387 8.06654C14.3786 8.2562 14.5186 8.54521 14.5186 8.85104V12.1002C14.5186 12.6524 14.0708 13.1002 13.5186 13.1002Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0186 11.4902C10.0186 10.9379 10.4663 10.4902 11.0186 10.4902C11.5708 10.4902 12.0186 10.9379 12.0186 11.4902V13.4902H10.0186V11.4902Z",
    fill: "currentColor"
  })));
};
export default SvgChatIcon;